import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import HeaderSection from '../HeaderSection/HeaderSection';
import PageHeader from '@components/PageHeader/PageHeader';
import { useAppPageControlledProperties } from '../AppPage/AppPageContext/AppPageContext';

const useStyles = makeStyles(() => ({
	header: {
		width: '100%',
		position: 'sticky',
		top: 0,
		zIndex: 110,
	},
}));

interface AppHeaderProps {
  hideRequestButton?: boolean;
  hideDropDown?: boolean;
  subHeaderTitle?: string;
}

export const AppHeader: React.FC<AppHeaderProps> = ({
	hideRequestButton,
	hideDropDown,
	subHeaderTitle,
}) => {
	const classes = useStyles();
	const { bodyClass, shouldApplyToHeader } = useAppPageControlledProperties();

	return (
		<Box className={classNames(classes.header, 'brand-0', 'background')}>
			<Box display="flex" justifyContent="center" flexDirection="column">
				<Box
					width={1}
					className={classNames({ [bodyClass]: shouldApplyToHeader })}
				>
					<HeaderSection
						hideRequestButton={hideRequestButton}
						hideDropDown={hideDropDown}
						data-field="header"
					/>
				</Box>
				{subHeaderTitle && <PageHeader title={subHeaderTitle} />}
			</Box>
		</Box>
	);
};
